import * as Sentry from '@sentry/browser'

import Client from 'utils/client'

const APPLICATION = 'dashboard'
const URL = 'v1/events'


// Emits an analytics event through the backend, which owns both the choice of
// analytics provider and the resolution of the caller's identity. Callers are
// user interactions, so this is deliberately fire-and-forget: it never blocks
// and never rejects.
//
// `application` is attached here rather than by the callers because the backend
// cannot work out which of our apps a request came from, and a caller that
// forgets it produces an event that nothing complains about.
//
export default function trackEvent(eventName, properties) {
  Client.post(URL, {
    event_name: eventName,
    properties: {
      ...properties,
      application: APPLICATION,
    },
  }).catch((error) => {
    Sentry.captureException(error, { level: 'warning' })
  })
}
